import React from 'react';
import NavBar from '../components/navbar';
import Markdown from '../components/markdown';
import '../styles/contentserv.css';
import index from '../data/index';
import { CircularProgress, Typography } from '@material-ui/core';

const markdownClass = "contentserv markdown";
const loadingClass = "contentserv loading";
const errorClass = "contentserv error";



class ContentServ extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            data: "",
            loaded: false,
            error: false,
        };
    }

    componentDidMount() {
        let file = index[this.props.klasse][this.props.theme]['types'][this.props.type];
        if (file === undefined || file === null) {
            console.error('Couldn\'t find the requested file!');
            this.setState({
                error: true,
            });
            return;
        }
        this.readTextFile(file);
    }

    async readTextFile(file) {
        var client = new XMLHttpRequest();
        client.onload = () => { this.setState({ data: client.responseText, loaded: true }) };
        client.onerror = () => { console.error('an error occured when sending the request: ' + client.status + ':' + client.statusText) };
        client.open("GET", file);
        client.send();
    }

    render() {
        if (this.state.error) {
            setTimeout(() => this.props.history.push('/'), 5000);
            return (
                <>
                    <NavBar />
                    <div className={errorClass}>
                        <Typography variant="h4">
                            An error occured while loading the page!<br />
                            It seems like the content you are looking for cannot be found.<br />
                            If you clicked on a link and landed here, please contact the webmaster.
                        </Typography>
                        <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                    </div>
                </>
            );
        }
        if (!this.state.loaded) {
            return (
                <>
                    <NavBar />
                    <CircularProgress className={loadingClass} />
                </>
            );
        }
        return (
            <>
                <NavBar />
                <div className={markdownClass}>
                    <Markdown source={this.state.data}>
                    </Markdown>
                </div>
            </>
        )
    }

}

export default ContentServ;